import React from 'react';
import Breadcrumb from './breadcrumb';

class Content extends React.Component {

    render() {

        const pathname = window.location.pathname

        return (
            <div style={pathname.includes('/report/resource') && !pathname.includes('/details') ? { backgroundColor: "#F9F7F5" } : { backgroundColor: "#FFF" } }>
                <Breadcrumb />
                {this.props.children}
            </div>
        )
    }
}

export default Content;





// WEBPACK FOOTER //
// ./src/components/front/content/content.js